webpackJsonp([245040273693158],{

/***/ 1529:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProviderCommissionInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"percent","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"productTypeId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-provider-commission-input-37d5648fdec7e3f175e4.js